export const I18N = Symbol.for('il18n');
export const LOCALE = Symbol.for('locale');
export const IG_API = Symbol.for('IgApi');
export const SAT_API = Symbol.for('SatApi');
export const MAP_API = Symbol.for('MapApi');
export const VIEW_API = Symbol.for('ViewApi');
export const ACT_API = Symbol.for('ActApi');
export const VUEX_STORE = Symbol.for('VuexStore');
export const MAP_MANAGER = Symbol.for('MapManager');
export const APOLLO_CLIENT = Symbol.for('ApolloClient');
export const AUTH_API = Symbol.for('AuthApi');
export const LOCATION_API = Symbol.for('LocationApi');
export const ENTITY_API = Symbol.for('EntityApi');
export const WICKET_API = Symbol.for('WicketApi');
export const HEADER_PANEL_API = Symbol.for('HeaderApi');
export const API_DEBOUNCE = Symbol.for('PromiseDebouncer');
export const FRONTEND_CONFIG = Symbol.for('FrontendConfig');
